module.exports = __webpack_public_path__ + "img/paypal-logo.d6b82776.svg";